import axios from "axios";

// 🔹 Instance pour l'API de login et autres requêtes principales
const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

console.log("🌍 API principale :", import.meta.env.VITE_API_URL);

// 🔹 Instance pour l'API d'évaluation
const evalApi = axios.create({
    baseURL: import.meta.env.VITE_REST_URL,
});

console.log("📊 API d'évaluation :", import.meta.env.VITE_REST_URL);

export { api, evalApi };
